var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smHtit w1200"},[_c('h2',[_c('a',{attrs:{"href":"/"}},[_vm._v("首页")]),_vm._v(">\n    "),_vm._l((_vm.navList),function(item,index){return _c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(item.name)+" "),(index+1 != _vm.navList.length)?_c('span',[_vm._v(" >")]):_vm._e()])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8c306f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/smalltit.vue
// module id = null
// module chunks = 